import { defineStore } from 'pinia'

/**
 * Customer Message Store — manages customer message unread counts.
 * Replaces the Vuex customerMessage store (store/customerMessage.js).
 *
 * Uses the CustomerMessageService which provides:
 * - counts() for unread/total message counts
 */
export const useCustomerMessageStore = defineStore('customerMessage', () => {
  const { $api } = useNuxtApp()

  const counts = ref<any>(null)
  const loading = ref(false)
  const error = ref<unknown>(null)
  let fetchPromise: Promise<void> | null = null

  /**
   * Fetch customer message counts (unread, total, etc.).
   */
  const fetchCounts = async () => {
    if (fetchPromise) return fetchPromise

    loading.value = true
    error.value = null
    fetchPromise = (async () => {
      try {
        const response = await $api.customerMessage.counts()
        if (response?.data) {
          counts.value = response.data
        }
      } catch (e) {
        error.value = e
        console.error('[useCustomerMessageStore] Failed to fetch counts:', e)
      } finally {
        loading.value = false
        fetchPromise = null
      }
    })()

    return fetchPromise
  }

  return {
    counts,
    loading,
    error,
    fetchCounts,
  }
})
